import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPaginationModule } from 'ngx-pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { GroupListComponent } from './groups/group-list.component';
import { GroupModalComponent } from './groups/group-modal.component';
import { UserListComponent } from './users/user-list.component';
import { UserModalComponent } from './users/user-modal.component';
import { LdapComponent } from './ldap/ldap.component';
import { UserSecurityConfigComponent } from './security-configuration/userSecurityConfig.component';
import { ProfileListComponent } from './profiles/profile-list.component';
import { ProfileModalComponent } from './profiles/profile-modal.component';
import { AccessControlComponent } from './access-control/access-control.component';
import { ExtractionPermissionListComponent } from './access-control/extraction-list/extraction-permission-list.component';
import { StatePermissionTableComponent } from './access-control/state-list/state-permission-table.component';
import { AccessControlModalComponent } from './access-control/access-control-modal.component';
import {CommonComponentsModule} from '../../common/common.module';
import {NgSelectModule} from '@ng-select/ng-select';
import {DropdownMultiselectComponent} from '../../common/dropdown-multiselect/dropdown-multiselect.component';




@NgModule({
  declarations: [
    GroupListComponent,
    GroupModalComponent,
    UserModalComponent,
    UserListComponent,
    LdapComponent,
    UserSecurityConfigComponent,
    ProfileListComponent,
    ProfileModalComponent,
    ExtractionPermissionListComponent,
    AccessControlComponent,
    StatePermissionTableComponent,
    AccessControlModalComponent
  ],
  entryComponents: [
    GroupListComponent,
    GroupModalComponent,
    UserModalComponent,
    UserListComponent,
    LdapComponent,
    UserSecurityConfigComponent,
    ProfileListComponent,
    ProfileModalComponent,
    ExtractionPermissionListComponent,
    AccessControlComponent,
    AccessControlModalComponent,
    DropdownMultiselectComponent
  ],
  imports: [
    CommonComponentsModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    NgxPaginationModule,
    NgSelectModule
  ],
  exports: [
    GroupListComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class AdminModule { }
